module.exports = __webpack_public_path__ + "static/img/首页图片2.a40d18a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/首页图片2.jpg
// module id = 63pf
// module chunks = 1